import { gql } from "@apollo/client";

export default gql`
  mutation clearException($data: ClearExceptionInput!) {
    clearException(data: $data)
  }
`;
